<template>
  <div class="layout-footer">
    <a href="https://sitbolivia.com/" target="_blank">
      <strong>SG-BOLIVIA VERSI&Oacute;N: </strong>
      <span class="version-badge">{{ version }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      version: "...",
    };
  },
  async mounted() {
    try {
      const response = await fetch("/version.json", { cache: "no-store" });

      if (response.ok) {
        const data = await response.json();
        this.version = data.version;
      } else {
        this.version = "1.0.0";
      }
    } catch (error) {
      this.version = "1.0.0";
    }
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.layout-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #002236;
}

.layout-footer a {
  color: #002236;
  text-decoration: none;
}

.layout-footer a:hover {
  text-decoration: underline;
}

.version-badge {
  background-color: #002236;
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.version-badge:hover {
  background-color: #003d5c;
}
</style>
